import { useState, useEffect } from "react";

import { convertToDDMMYYYY } from "../Utils/dateconverter.jsx";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css"; // Ensure Bootstrap Icons are
import "../css/Home_20260402.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import iconexcel from "../images/iconexcel.png";
import PaginationCustom from "./PaginationCustom.jsx";
import { useOutletContext } from "react-router-dom";
import backendUrl from "../Utils/backendUrl";

export default function Home() {
  const {
    userData,
    sharedStartDate,
    setSharedStartDate,
    sharedEndDate,
    setSharedEndDate,
    MIN_DATE,
    today,
  } = useOutletContext();

  let [cardsdata, setCardData] = useState([]);
  const [selectedZone, setSelectedZone] = useState("0");
  const [selectedRange, setSelectedRange] = useState("0");
  const [selectedDistrict, setSelectedDistrict] = useState("0");
  const [selectedStation, setSelectedStation] = useState({
    code: "",
    name: "",
  });

  const [c_usertype, set_c_UserType] = useState(userData.usertype);
  // const [c_userid, set_c_userid] = useState(userData.id);
  let [locationCode,setLocationCode]=useState(userData.location_code || "");

  const [stationCode, setStationCode] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const [rangeCode, setRangeCode] = useState("");
  const [zoneCode, setZoneCode] = useState("");

  const [zonelist, setZonelist] = useState([]);
  const [rangelist, setRangelist] = useState([]);
  const [districtlist, setDistrictlist] = useState([]);
  const [pslist, setPslist] = useState([]);

  let [selectedLinked, setSelectedLinked] = useState("0");
  let [combined, setCombined] = useState("0");
  let [page, setPage] = useState(1);
  let [totalPages, setTotalPages] = useState(1);
  let [limit] = useState(10);
  let [searchvalue, setSearchValue] = useState("");
  let [searchtrue, setSearchTrue] = useState(true);
  let [searchSubmit, setSearchSubmit] = useState(false);
  const [downloading, setDownloading] = useState(false);

  // Local picker state (modal only)
  const [startDate, setStartDate] = useState(sharedStartDate || "");
  const [endDate, setEndDate]     = useState(sharedEndDate   || "");

  // Applied dates come from shared context
  const appliedStartDate = sharedStartDate;
  const appliedEndDate   = sharedEndDate;

  const [showFilter, setShowFilter] = useState(false);


//=========================================================
// LOCATION CODE HELPER
//=========================================================

  const getLocationCode = (districtCode, rangeCode, zoneCode,locationCode ) => {
  return (
    districtCode ||
    rangeCode ||
    zoneCode ||
    locationCode ||
    ""
  );
};
//=========================================================



  // Sync local picker with shared state each time the modal opens
  // If dates are null/empty, keep boxes blank (do not show default dates)
  useEffect(() => {
    if (showFilter) {
      setStartDate(sharedStartDate || "");
      setEndDate(sharedEndDate || "");
    }
  }, [showFilter, sharedStartDate, sharedEndDate]);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const HandleGetSearchValue = (e) => {
    let value = e.target.value;

    const currentYear = new Date().getFullYear(); // 2026
    const shortYear = currentYear % 100; // 26

    if (value.length === 0) {
      setSearchValue("");
      // document.body.classList.add("opacitypage");
      setSearchTrue(!searchtrue);
      setSelectedLinked(0);
      return;
    }

    const firstChar = value.charAt(0);

    // ======================================
    // Number Search
    // ======================================
    if (/^\d/.test(firstChar)) {
      // allow only digits and one /
      value = value.replace(/[^0-9/]/g, "");

      const slashIndex = value.indexOf("/");

      // No slash => allow up to 16 digits
      if (slashIndex === -1) {
        value = value.slice(0, 16);
      } else {
        // allow only first slash
        value =
          value.substring(0, slashIndex + 1) +
          value.substring(slashIndex + 1).replace(/\//g, "");

        let [firNo = "", year = ""] = value.split("/");

        // FIR No max 4 digits
        firNo = firNo.slice(0, 4);

        // FIR must be 1-9999 when complete
        if (firNo && parseInt(firNo, 10) < 1) {
          firNo = "";
        }

        // ==========================
        // Year Validation
        // Allowed:
        // 17-26
        // 2017-2026
        // ==========================
        if (year) {
          year = year.slice(0, 4);

          if (year.length === 1) {
            // first digit must be 1 or 2
            if (!/^[12]$/.test(year)) {
              year = "";
            }
          } else if (year.length === 2) {
            const yy = parseInt(year, 10);

            if (yy < 17 || yy > shortYear) {
              year = "";
            }
          } else if (year.length === 3) {
            // only allow 201 or 202
            if (!/^20[12]$/.test(year)) {
              year = "";
            }
          } else if (year.length === 4) {
            const yyyy = parseInt(year, 10);

            if (yyyy < 2017 || yyyy > currentYear) {
              year = "";
            }
          }
        }

        value = firNo;

        if (slashIndex !== -1) {
          value += "/";
        }

        if (year) {
          value = `${firNo}/${year}`;
        }
      }
    }

    // ======================================
    // Name Search
    // ======================================
    else if (/^[a-zA-Z]/.test(firstChar)) {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    }

    // ======================================
    // Invalid Start Character
    // ======================================
    else {
      value = "";
    }

    setSearchValue(value);
  };


  // submit search
  const HandleSearchSubmit = (event) => {
    event.preventDefault(); // Prevent page reload
    console.log("searchvalue " + searchvalue);
    // document.body.classList.add("opacitypage");

    setSearchTrue(!searchtrue);
    setSearchSubmit(!searchSubmit);
    // setSearch(searchvalue);
    setPage(1);
    setSearchTrue(false);

    if (!searchvalue.includes("/")) {
      //reset
      setSelectedZone("0");
      setSelectedRange("0");
      setSelectedDistrict("0");
      setSelectedStation({ code: "0", name: "Select Station" });
    }

    setSelectedLinked(2);
    setCombined(0);

    if (searchvalue === "") {
      setSelectedLinked(0);
    }
  };

  // handel pagination
  const handlePageChange = (value) => {
    // console.log("called pagination "+value);
    // document.body.classList.add("opacitypage");
    if (value === "&laquo;" || value === "... ") {
      setPage(1);
    } else if (value === "&lsaquo;") {
      if (page !== 1) {
        setPage(page - 1);
      }
    } else if (value === "&rsaquo;") {
      if (page !== totalPages) {
        setPage(page + 1);
      }
    } else if (value === "&raquo;" || value === " ...") {
      setPage(totalPages);
    } else {
      setPage(value);
    }
    // document.body.classList.remove("opacitypage");
  };

  // handle combined dropdwon
  const handleCombind = (event) => {
    // document.body.classList.add("opacitypage");
    setPage(1);
    setSearchValue("");
    if (event.target.value > 0) {
      setSelectedLinked(0);
    }
    setCombined(event.target.value);
  };

  //handle linked dropdwond
  const handleLinked = (event) => {
    document.body.classList.add("opacitypage");
    setPage(1);
    setSearchValue("");
    if (event.target.value > 0) {
      setCombined(0);
    }
    setSelectedLinked(event.target.value);
  };



//====================================================
// handle zone, range, District And Station 
//=====================================================


// handle zone 

const handleZone = (e) => {
    const zone = e.target.value;
    console.log("Selected Zone:", zone);

    if (zone === "0") {
      set_c_UserType(userData.usertype);

      setSelectedZone("0");

    } else {

      setSelectedZone(zone);
      set_c_UserType(7);
    
    }

      setZoneCode(zone);

    // RESET SELECTED VALUES
    setSelectedRange("0");
    setSelectedDistrict("0");

    setSelectedStation({
      code: "0",
      name: "Select Station",
    });

    // CLEAR LISTS
    setRangelist([]);
    setDistrictlist([]);
    setPslist([]);

    setPage(1);
  };

  // Select Range

  const handleRange = (e) => {
    const range = e.target.value;

    console.log("Selected Range:", range);

    if (range === "0") {
      // set_c_userid(userData.userid);

      set_c_UserType(userData.usertype);

      setSelectedRange("0");

      // setr_Userid("0");
    } else {
      setSelectedRange(range);

      // setr_Userid(range);

      set_c_UserType(6);

      // set_c_userid(range);
    }

  setRangeCode(range);

    // RESET LOWER

    setSelectedDistrict("0");

    setSelectedStation({
      code: "0",
      name: "Select Station",
    });

    setDistrictlist([]);

    setPslist([]);

    setPage(1);
  };

  // Select District

  const handleDistrict = (e) => {
    const district = e.target.value;
    console.log("Selected District:", district);
    if (district === "0") {
      // set_c_userid(userData.userid);

      set_c_UserType(userData.usertype);

      setSelectedDistrict("0");

    } else {
      setSelectedDistrict(district);


      // set_c_userid(district);

      set_c_UserType(5);
    }
    setDistrictCode(district);
    setSelectedStation({
      code: "0",
      name: "Select Station",
    });

    setPslist([]);

    setPage(1);
  };

  // Select Station
  const handleStation = (event) => {
    
    const code = event.target.value;
    const station = pslist.find((item) => item.station_code === code);
    
    setSelectedStation({
      code: code,
      name: station ? station.station_name : "",
    });
    // console.log("selectedStation.code  ", selectedStation );
    setPage(1);
    setSearchValue("");
  };

//============================================================

//=========================================================
//excel download
// =========================================================

  const handleDownloadExcelX = async () => {
    if (downloading) return;

    try {
      setDownloading(true);

      const response = await axios.get(`${backendUrl}exportexcel`, {
        params: {
          selectedLinked,
          combined,
          code: selectedStation.code,
          stationName: selectedStation.name,
          // userid: c_userid,
          usertype: c_usertype,
          status: "active",
          startDate: appliedStartDate,
          endDate: appliedEndDate,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", `E-Sakshya ${userData.name}.xlsx`);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      // Wait 3 seconds before allowing next click
      setTimeout(() => {
        setDownloading(false);
      }, 3000);

    } catch (error) {
      console.error("Download failed:", error);
      setDownloading(false);
    }
  };







//=========================================================
// EXCEL DOWNLOAD
//=========================================================

const handleDownloadExcel = async () => {
  if (downloading) return;

  try {
    setDownloading(true);

    const token = localStorage.getItem("token");

    // Same location priority as sidview
    const currentLocationCode = getLocationCode(
      districtCode,
      rangeCode,
      zoneCode,
      locationCode
    );

    console.log("Excel Download Params:", {
      usertype: c_usertype,
      page,
      totalPages,
      code: selectedStation?.code || "",
      stationName: selectedStation?.name || "",
      selectedLinked,
      combined,
      limit,
      status: "active",
      districtCode: districtCode || "",
      rangeCode: rangeCode || "",
      zoneCode: zoneCode || "",
      search: searchvalue || "",
      startDate: appliedStartDate,
      endDate: appliedEndDate,
      locationCode: currentLocationCode,
    });

    const response = await axios.get(`${backendUrl}exportexcel`, {
      params: {
        usertype: c_usertype,

        page,
        totalPages,

        code: selectedStation?.code || "",
        stationName: selectedStation?.name || "",

        selectedLinked,
        combined,
        limit,

        status: "active",

        districtCode: districtCode || "",
        rangeCode: rangeCode || "",
        zoneCode: zoneCode || "",

        search: searchvalue || "",

        startDate: appliedStartDate,
        endDate: appliedEndDate,

        // Same locationCode used by sidview
        locationCode: currentLocationCode,
      },

      headers: {
        Authorization: `Bearer ${token}`,
      },

      responseType: "blob",
    });

    //=====================================================
    // DOWNLOAD FILE
    //=====================================================

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `E-Sakshya ${userData?.name || "Report"}.xlsx`
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);

    // Wait 3 seconds before allowing another download
    setTimeout(() => {
      setDownloading(false);
    }, 3000);

  } catch (error) {
    console.error("Excel download failed:", error);

    setDownloading(false);
  }
};
  //=========================================================


// ============================================================
// SID VIEW API FUNCTION
// ============================================================



const sidview = async () => {
  try {
    document.body.classList.add("opacitypage");

    const token = localStorage.getItem("token");
   
    const currentLocationCode = getLocationCode(
      districtCode,
      rangeCode,
      zoneCode,
      locationCode,
    );

    const response = await axios.get(`${backendUrl}sidview`, {
      params: {
        usertype: c_usertype,
        page,
        totalPages,
        code: selectedStation.code,
        stationName: selectedStation.name,
        selectedLinked,
        combined,
        limit,
        status: "active",
        districtCode: districtCode,
        rangeCode: rangeCode,
        zoneCode: zoneCode,
        search: searchvalue,
        startDate: appliedStartDate,
        endDate: appliedEndDate,
        locationCode: currentLocationCode,
      },

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setCardData(response.data.data);
    setTotalPages(response.data.totalPages);

  } catch (error) {
    console.error("Error fetching sidview:", error);

    // Optional
    setCardData([]);
    setTotalPages(0);

  } finally {
    document.body.classList.remove("opacitypage");
  }
};

useEffect(() => {
  document.title = "CopSuvidha/Home";
  sidview();
}, [
  selectedStation.code,
  selectedStation.name,
  selectedLinked,
  combined,
  page,
  searchSubmit,
  searchtrue,
  selectedDistrict,
  appliedStartDate,
  appliedEndDate,
  c_usertype,
  districtCode,
  rangeCode,
  zoneCode,
  locationCode
]);

// ============================================================




// ============================================================
// LOAD SID VIEW
// ============================================================
 

  const handleApply = () => {
    // both must be filled OR both must be empty
    if ((startDate && !endDate) || (!startDate && endDate)) {
      alert("Please select both Start Date and End Date");
      return;
    }

    // Start <= End
    if (startDate > endDate) {
      alert("Start Date cannot be greater than End Date");
      return;
    }

    // Future dates not allowed
    if (startDate > today || endDate > today) {
      alert("Future dates are not allowed");
      return;
    }

    setShowFilter(false);
    // Write to shared context → syncs Dashboard too
    setSharedStartDate(startDate);
    setSharedEndDate(endDate);
  };

  const handleStarEndtDate = (e) => {
    const value = e.target.value;

    if (value && value < MIN_DATE) {
      alert("Start Date cannot be less than 01/07/2024");
      return;
    }

    if (value && value > today) {
      alert("Start Date cannot be greater than today's date");
      return;
    }

    setStartDate(value);

    // If end date becomes invalid reset it
    if (endDate && value && value > endDate) {
      setEndDate(value);
    }
  };

  const handleEndDate = (e) => {
    const value = e.target.value;

    if (value && value > today) {
      alert("End Date cannot be greater than today's date");
      return;
    }

    if (value && startDate && value < startDate) {
      alert("End Date cannot be less than Start Date");
      return;
    }

    setEndDate(value);
  };



// ============================================================
// LOAD ZONE LIST
// ============================================================
const zoneList = async () => {
  try {
    if (!userData?.userid) {
      setZonelist([]);
      return;
    }

    const res = await axios.get(`${backendUrl}zonelist`, {
      params: {
        userid: userData.userid,
      },
    });

    // console.log("API Zone List:", res.data);

    setZonelist(res.data);
  } catch (error) {
    console.error("Error fetching zone list:", error);
    setZonelist([]);
  }
};

useEffect(() => {
  // console.log("zone list useEffect called with userData:", userData);

  // Only usertype 0 (Admin) can load zone list
  if (Number(userData?.usertype) !== 0) {
    setZonelist([]);
    return;
  }

  zoneList();

}, [userData?.usertype, userData?.userid]);


//=================================================


// =========================================================
// RANGE LIST
// =========================================================

const rangeList = async (locationCode) => {
  console.log(" you have called raneList. locationCode ", locationCode);
  try {
    const res = await axios.get(`${backendUrl}rangelist`, {
      params: {
        locationCode: locationCode,
      },
    });

    setRangelist(res.data);

    // console.log("Range List:", res.data);
  } catch (error) {
    console.error("Error loading range list:", error);
  }
};

useEffect(() => {
  if (zoneCode) {
    rangeList(zoneCode);
  }
}, [zoneCode]);

// =========================================================


// =========================================================
// DISTRICT LIST
// =========================================================

const districtList = async (districtCode) => {
  try {
    const res = await axios.get(`${backendUrl}districtlist`, {
      params: {
        districtCode: Number(districtCode),
      },
    });

    setDistrictlist(res.data);

  } catch (error) {
    console.error("Error loading district list:", error);
  }
};

useEffect(() => {
  if (rangeCode) {
    districtList(rangeCode);
  }
}, [rangeCode]);


//=========================================================


//==========================================================
// POLICE STATION LIST
//==========================================================

const psList = async (districtCode) => {
  try {
    // console.log("Calling psList with districtCode:", districtCode);

    if (!districtCode || Number(districtCode) === 0) {
      setPslist([]);
      return;
    }

    const res = await axios.get(`${backendUrl}pslist`, {
      params: {
        districtCode: Number(districtCode),
      },
    });

    setPslist(res.data);

    // console.log("PS List:", res.data);
  } catch (error) {
    console.error("Error fetching PS list:", error);
    setPslist([]);
  }
};


  
useEffect(() => {
  // console.log("districtCode changed:", districtCode);

  psList(districtCode);
}, [districtCode]);


//==========================================================


useEffect(() => {
  const loadUserArea = async () => {
    if (!userData?.usertype) {
      return;
    }

    const userType = Number(userData.usertype);
    const locationCode = Number(userData.location_code) || 0;

    try {
      if (userType === 5) {
        // DISTRICT USER
        setDistrictCode(locationCode);

      } else if (userType === 6) {
        // RANGE USER
        setRangeCode(locationCode);

        // Get districts under this range
        await districtList(locationCode);

      } else if (userType === 7) {
        // ZONE USER
        setZoneCode(locationCode);

        await rangeList(locationCode);

      } else if (userType === 1) {
        // STATION USER
        setLocationCode(locationCode);

      } else if (userType === 0) {
        // ADMIN
        // No area restriction
        // setStationCode(userData.location_code);
      }

    } catch (error) {
      console.error("Error loading user area:", error);
    }
  };

  loadUserArea();

}, [userData?.usertype, userData?.location_code]);



  return (
    <>
      <div className="container position-relative">
        <div className="row justify-content-end mt-3">
          {/* select Zone   */}
          {userData.usertype === 0 && (
            <div className="col-md-2">
              <select
                className="form-select"
                value={selectedZone}
                onChange={handleZone}
                disabled={searchvalue !== ""}
              >
                <option value="0">Select Zone</option>

                {zonelist.map((item) => (
                  <option key={item.zone_code} value={item.zone_code}>
                    {item.zone_name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* select Range   */}
          {(userData.usertype == 7 || userData.usertype == 0) && (
            <div className="col-md-2">
              <select
                className="form-select"
                value={selectedRange}
                onChange={handleRange}
                disabled={searchvalue !== ""}
              >
                <option value="0">Select Range</option>

                {rangelist.map((item) => (
                  <option key={item.range_code} value={item.range_code}>
                    {item.range_name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* select District   */}
          {(userData.usertype === 6 ||
            userData.usertype === 7 ||
            userData.usertype === 0) && (
            <div className="col-md-2">
              <select
                className="form-select"
                aria-label="Default select example"
                value={selectedDistrict}
                onChange={handleDistrict}
                disabled={searchvalue !== ""}
              >
                <option value="0">Select District</option>
                {districtlist.map((item, index) => (
                  <option
                    key={index}
                    data-name={item.district_name}
                    value={item.district_code}
                  >
                    {item.district_name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* select police station   */}

          {(userData.usertype === 5 ||
            userData.usertype === 6 ||
            userData.usertype === 7 ||
            userData.usertype === 0) && (
            <div className="col-md-2">
              <select
                className="form-select"
                aria-label="Default select example"
                value={selectedStation.code}
                onChange={handleStation}
                disabled={searchvalue !== ""}
              >
                <option value="0">Select Station</option>
                {pslist.map((item, index) => (
                  <option
                    key={index}
                    data-name={item.station_name}
                    value={String(item.station_code)}
                  >
                    {item.station_name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* select combined/self/ other linked SID */}
          <div className="col-md-2">
            <select
              className="form-select"
              value={combined}
              onChange={handleCombind}
              disabled={searchvalue !== ""}
            >
              <option value={0}>Combined Linked FIR </option>
              <option value={1}>Linked to Other Office</option>
              <option value={2}>Linked to Self</option>
            </select>
          </div>

          <div className="col-md-2">
            <select
              className="form-select"
              value={selectedLinked}
              onChange={handleLinked}
              disabled={searchvalue !== ""}
            >
              <option value={0}>FIR WITH SID</option>
              <option value={1}>FIR WITHOUT SID</option>
              <option value={5}>PENDING FIR WITHOUT SID </option>
              <option value={6}>COMPLETED FIR WITHOUT SID </option>
              <option value={2}>ALL FIR </option>
              <option value={3}>Pending for Final Linking </option>
              <option value={4}>Pending for Linking </option>
             
            </select>
          </div>
          <div className="col-md-1">
             <button
                className="btn btn-warning d-flex align-items-center gap-1"
                disabled={searchvalue !== ""}
                onClick={() => setShowFilter(true)}
              >
                <i className="bi bi-calendar3-range-fill"></i>
                <span>Filter</span>
              </button>
          </div>
        </div>
      </div>
      <div className="container my-1">
        <div className="row align-items-center justify-content-between">
          {/* Download Button */}
          <div className="col-auto">
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center icon-excel"
              onClick={handleDownloadExcel}
              disabled={searchvalue !== "" || downloading}
            >
              <span>Download</span> <img src={iconexcel} alt="Download" />
            </button>
          </div>

          {/* Date Range Display - only visible when dates are applied */}
          <div className="col text-center">
            {appliedStartDate && appliedEndDate && (
              <div className="date-range-display">
                <i className="bi bi-calendar3-range-fill date-range-icon"></i>
                <span className="date-range-text">
                  Date Range:&nbsp;
                  {appliedStartDate.split("-").reverse().join(".")}
                  &nbsp;to&nbsp;
                  {appliedEndDate.split("-").reverse().join(".")}
                </span>
                <i className="bi bi-calendar3-range-fill date-range-icon"></i>
              </div>
            )}
          </div>

          {/* Search */}
          <div className="col-md-4">
            <form className="d-flex" onSubmit={HandleSearchSubmit}>
              <div className="input-group position-relative">
                <input
                  className="form-control fs-5"
                  type="search"
                  placeholder="Search..officerName/SID/FIR"
                  aria-label="Search"
                  value={searchvalue}
                  onChange={HandleGetSearchValue}
                  autoComplete="off"
                />
                {searchvalue && (
                  <span
                    style={{
                      position: "absolute",
                      right: "45px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      zIndex: 2,
                    }}
                    onClick={() => {
                      setSearchValue("");
                    }}
                  >
                    <i className="bi bi-x fs-5"></i>
                  </span>
                )}
                <button className="btn btn-primary px-1" type="submit">
                  <i className="bi bi-search fs-5 px-2"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="container table-container  position-relative">
        {/* table container  */}
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Sr.No</th>
              <th>Office Name</th>
              <th>Officer Name</th>
              <th>SID</th>
              <th>FIR No.</th>
              <th>FIR Date</th>
              <th>LATITUDE</th>
              <th>LONGITUDE</th>
              <th>Current Status</th>
              <th>SID Opening Date</th>
              <th>SID Uploading Date</th>
              <th>STATUS</th>
              <th>IO Name</th>
              <th>PS NAME</th>
            </tr>
          </thead>
          <tbody>
            {cardsdata.length > 0 ? (
              cardsdata.map((item, index) => {
                // let fir_date_convert =convertToDDMMYYYY(item.fir_date);
                // console.log(index, fir_date_convert);
                return (
                  <tr key={index}>
                    <td>{index + 1 + (page - 1) * limit}</td>
                    <td
                      className={`${
                        item.Office_Name !== item.station_name
                          ? "bg-danger text-white fw-bold fs-7"
                          : ""
                      }`}
                    >
                      {item.Office_Name}
                    </td>
                    <td>{item.Officer_Name}</td>
                    <td>{item.SID}</td>
                    <td>{item.FIR_No}</td>

                    <td>
                      {item.fir_date &&
                      !isNaN(new Date(item.fir_date).getTime())
                        ? convertToDDMMYYYY(item.fir_date)
                        : ""}
                    </td>
                    <td>{item.LATITUDE}</td>
                    <td>{item.LONGITUDE}</td>
                    <td>{item.Current_Status}</td>
                    <td>{item.SID_Opening_Date}</td>
                    <td>{item.SID_Uploading_Date}</td>
                    <td>{item.status_}</td>
                    <td>{item.io_name}</td>
                    <td
                      className={`${
                        item.Office_Name !== item.station_name
                          ? "bg-danger text-white fw-bold fs-7"
                          : ""
                      }`}
                    >
                      {item.station_name}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={14} className="text-center">
                  Data is not found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <PaginationCustom
        page={page}
        totalPages={totalPages}
        limit={limit}
        siblings={1}
        onPageChange={handlePageChange}
      />

      {showFilter && (
        <>
          {/* Backdrop */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{
              background: "rgba(0,0,0,0.5)",
              zIndex: 1040,
            }}
            onClick={() => setShowFilter(false)}
          ></div>

          {/* Modal */}
          <div
            className="position-fixed top-50 start-50 translate-middle"
            style={{
              zIndex: 1050,
              width: "400px",
            }}
          >
            <div className="card shadow-lg">
              <div className="card-header d-flex text-center bg-warning justify-content-between align-items-center">
                <h5 className="mb-0 ">Filter FIR-SID</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFilter(false)}
                ></button>
              </div>

              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    min={MIN_DATE}
                    max={endDate || today}
                    onChange={handleStarEndtDate}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    min={startDate}
                    max={today}
                    onChange={handleEndDate}
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      // Only clear the picker boxes — does NOT apply until user clicks Apply
                      setStartDate("");
                      setEndDate("");
                    }}
                  >
                    Reset
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      handleApply();
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
